import theme from '~lib/styles/Theme';
import { ToastVariant } from '~store/toast';

export function getBackgroundColorByVariant(variant: ToastVariant) {
  switch (variant) {
    case 'danger':
      return theme.colors.red500;
    default:
      return theme.colors.gray900;
  }
}
